var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.167 13.833h1.187L11.5 5.688 10.313 4.5l-8.146 8.146zM.5 15.5v-3.542L11.5.98q.25-.229.552-.354T12.688.5t.645.125q.314.124.542.375l1.146 1.167q.25.229.364.541a1.8 1.8 0 0 1 0 1.26 1.6 1.6 0 0 1-.364.553L4.04 15.5zM10.896 5.104l-.584-.604L11.5 5.688z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.e99576f1738b008e700bd8ffe323f94e.svg";
export { ForwardRef as ReactComponent };